import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'hc-hygiene-check-evaluation',
  templateUrl: './hygiene-check-evaluation.component.html',
  styleUrls: ['./hygiene-check-evaluation.component.css']
})
export class HygieneCheckEvaluationComponent implements OnInit {

  @Output() childData = new EventEmitter();
  @Input() filterDetails
  constructor() { }

  ngOnInit() {
  }  
  emitData(valve){
    this.childData.emit(valve)
  }
}